module.exports = __webpack_public_path__ + "static/img/2-3-5.aaf2a888.jpg";